module.exports = __webpack_public_path__ + "static/media/vic-govt-logo-original.d33b860a.png";